angular.module('iqxCore')
.controller('PinCtrl', function ($scope, pinSvc, $routeParams, ApplicationSvc, inactivitySvc) {
  if ($routeParams && $routeParams.inactivity && $routeParams.inactivity==='true') {
    $scope.inactivity=true
  }

  $scope.auth=function(){
    pinSvc.unlock($scope.pin)
    .then(function(r){
      if(ApplicationSvc.isSwitchedOn("AUTO_LOGOUT")){
        inactivitySvc.enable()
        inactivitySvc.callBack=function(){
          inactivitySvc.disable()
          pinSvc.lock(true)
        }
      }
    })
  }
})
